exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mdt-offers-wrap[_v-40935183]{background-color:#fafafa;width:100%}.section-title h2[_v-40935183]{font-weight:800;text-align:center}.categories-caroursel-wrap[_v-40935183]{padding:5px 0}.articles-list[_v-40935183]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-top:10px;margin-bottom:50px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.articles-list>div[_v-40935183]{cursor:pointer;-ms-flex-preferred-size:0;flex-basis:0}@media (max-width:1250px){.articles-list[_v-40935183]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-40935183&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/utilities/market-section.vue
// module id = 352
// module chunks = 0